var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackSchoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3007_6147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4.2L10.7333 6.06667V13.5333H3.26667V6.06667L7 4.2ZM7 4.2V0M0 13.5333H14M1.4 13.5333V7.93333H3.26667M12.6 13.5333V7.93333H10.7333M6.06667 13.5333V10.7333H7.93333V13.5333M7 0.466667H9.8V2.33333H7M7 8.86667C6.48454 8.86667 6.06667 8.44879 6.06667 7.93333C6.06667 7.41787 6.48454 7 7 7C7.51546 7 7.93333 7.41787 7.93333 7.93333C7.93333 8.44879 7.51546 8.86667 7 8.86667Z",
    stroke: "#2F1C0A",
    strokeWidth: 0.933333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3007_6147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSchoolIcon);
export default __webpack_public_path__ + "static/media/blackSchoolIcon.8b673f2997538ac822661c910a1536b1.svg";
export { ForwardRef as ReactComponent };